import React from "react";

const HomeContext = React.createContext({
  currentSection: 0,
  setCurrentSection: () => {},
});

export default HomeContext;
